module.exports = __webpack_public_path__ + "static/media/kitchenmarket_thumb.a94ddfc5.jpg";